import AttachmentIcon from "@mui/icons-material/Attachment"
import { Button } from "@mui/material"
import { makeStyles } from "tss-react/mui-compat"
import React from "react"

interface AttachmentProps {
  caption: string
  onClick: React.MouseEventHandler<HTMLButtonElement>
}

const useStyles = makeStyles()({
  label: {
    fontSize: 16,
    textTransform: "capitalize",
  },
})

const Attachment = (props: AttachmentProps) => {
  const { caption, onClick } = props
  const { classes } = useStyles()

  return (
    <Button onClick={onClick} startIcon={<AttachmentIcon fontSize="inherit" />} variant="text">
      <span className={classes.label}>{caption}</span>
    </Button>
  )
}

export default Attachment
